import { useUpdateScheduledPost } from 'hooks/queries/scheduledPosts/useUpdateScheduledPost'
import { useDebouncedCallback } from '@react-hookz/web'
import type { ScheduledPostShow, EmailPostSettings } from 'api/clients/ScheduledPostsClient'

export const useEmailSubjectLine = (scheduledPost: ScheduledPostShow | undefined) => {
  const updateScheduledPost = useUpdateScheduledPost({ suppressToast: true })

  const handleUpdateSubjectLine = (subjectLine: string) => {
    if (!scheduledPost) return

    updateScheduledPost.mutate({
      id: scheduledPost.id,
      params: { postSettings: { ...scheduledPost.post_settings, subject_line: subjectLine } },
    })
  }

  const debouncedUpdateSubjectLine = useDebouncedCallback(
    (subjectLine: string) => {
      handleUpdateSubjectLine(subjectLine)
    },
    [handleUpdateSubjectLine],
    500,
  )

  const subjectLine = (scheduledPost?.post_settings as EmailPostSettings)?.subject_line

  return {
    subjectLine,
    handleUpdateSubjectLine: debouncedUpdateSubjectLine,
    isUpdating: updateScheduledPost.isLoading,
  }
}
